module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"today":"Today","complete-today":"Completed<br>Today"},"fr":{"today":"Aujourd\u0027hui","complete-today":"Complétée<br>Aujourd\u0027hui"}}')
  delete Component.options._Ctor
}
